import { isSalesPartyPhoneComplete } from './salesPartyPhone';

const present = value => String(value || '').trim().length > 0;

export const applySalesPartyPhoneError = (source, errors, t) => {
  if (
    present(source?.phone) &&
    !isSalesPartyPhoneComplete(source?.country_code, source.phone)
  ) {
    errors.phone = t('SALES_PARTIES.FORM.PHONE_INVALID');
  }
  return errors;
};
